export default __webpack_public_path__ + "144cd62221b4c46a78cb13cec4478485.png";